import axios from 'axios';
import { AF_API_HOST, downloadDocumentApi } from 'reactApp/api/axios.corsapi';

import { sendMyofficeGa } from './sendMyofficeGa';

export const downloadDocumentMail = async (url?: string): Promise<{ content?: Nullable<ArrayBuffer>; error?: unknown }> => {
    if (!url) {
        return {};
    }

    try {
        const { data: content } = await downloadDocumentApi(url);

        sendMyofficeGa('download-success');
        return { content };
    } catch (error) {
        sendMyofficeGa('download-error');
        return { error };
    }
};

export const downloadDocumentWithoutRedirect = async (url: string): Promise<{ content?: ArrayBuffer; error?: unknown }> => {
    if (!url) {
        return {};
    }

    try {
        const { data: loadAttachInfo } = await axios.get(url, {
            params: {
                // Этот параметр запрещает редирект при походе на /getattach
                // Нам это нужно, чтобы самостоятельно сходить на af-ы (следующий запрос)
                // В противном случае не прокидывается заголовок Origin
                ajax_call: '1',
            },
            withCredentials: true,
        });

        const afUrl = loadAttachInfo.find((param) => param.includes(AF_API_HOST));

        if (!afUrl) {
            return { error: 'no_af_url' };
        }

        const { data: content } = await axios.get(afUrl, {
            withCredentials: true,
            responseType: 'arraybuffer',
        });

        return { content };
    } catch (error) {
        return { error };
    }
};
